





















































































































import {GroupsApplicationItem} from '@/store/push/groups_application/types';
import {Component, Watch} from 'vue-property-decorator';
import {Action, Getter} from 'vuex-class';
import {ScrollButton} from "wings-ui-components";
import BaseItemsPage from "@/pages/Pages/BaseItemsPage";
import draggable from 'vuedraggable'
import {cloneDeep} from "lodash";
import PushGroupsApplicationsFilter from "@/components/Push/Applications/PushGroupsApplicationsFilter.vue";
import CallDetailIncomingFilter from "@/components/Call/Statistic/CallDetailIncomingFilter.vue";
import {getTranslatedParams} from "@/utils/notify-utils";
import {ActionLog} from "@/store/auth/types";

@Component({components: {CallDetailIncomingFilter, PushGroupsApplicationsFilter, ScrollButton, draggable}})
export default class PushGroupsApplications extends BaseItemsPage<GroupsApplicationItem> {
  @Action("saveGroupsApplicationPriority") savePriority: any;
  @Getter("groupsApplications") responseItems: any;
  @Action("actionLog") actionLog: any;

  private is_show_filter = false;
  private modelDragon: any = [];
  private logObject: ActionLog = {};

  currentSortOrder = "asc";
  tableFields = ['id', 'name', 'description'];

  getData(): any {
    this.modelDragon = cloneDeep(this.responseItems);
    return this.responseItems;
  }

  @Watch('modelDragon', {deep: true})
  async onModelChange(val: any,new_val:any) {
    let ids: any = [];
    val.forEach((e: any) => ids.push(Number(e.id)));
    if (ids.length && new_val.length) {
      try {
        this.logObject = {
          action_page: this.$route.meta.msgKey,
          action: "Editing",
          action_status: "success",
          object_type: "Push-applications group",
          addititional_info: getTranslatedParams({push_applications_groups_priority: ids})
        }
        await this.savePriority({applications_groups: ids});
        await this.actionLog(this.logObject);
      } catch(error) {
        this.actionLog({...this.logObject, action_status: "failed"});
      }
    }
  }
};

